import { useMoralis } from 'react-moralis';
import { Link } from 'react-router-dom';
import './secondarynav.css';
export const SecondaryNavigation = () => {
  const { logout, isAuthenticated, isAuthenticating } = useMoralis();

  const renderButtons = () => {
    if(isAuthenticated){
      return  <>
                <button className='logout-button' onClick={logout} disabled={isAuthenticating}>Logout</button>
              </>
    }
  }
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='/'>
            <img className="main-header-logo" src="img/logo.svg" alt="Logo"/>
          </a>{' '}
        </div>
        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='/' className='page-scroll'>
              ← Back to main site
              </a>
            </li>
            <li><Link to="/whitelist">Whitelist</Link></li>
            <li><Link to="/mint">Mint</Link></li>
            { renderButtons() }
          </ul>
        </div>
      </div>
    </nav>
  )
}